import { render, staticRenderFns } from "./noticUserList.vue?vue&type=template&id=4553bde9&"
import script from "./noticUserList.vue?vue&type=script&lang=js&"
export * from "./noticUserList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4553bde9')) {
      api.createRecord('4553bde9', component.options)
    } else {
      api.reload('4553bde9', component.options)
    }
    module.hot.accept("./noticUserList.vue?vue&type=template&id=4553bde9&", function () {
      api.rerender('4553bde9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/noticUserList.vue"
export default component.exports